"use client";

import Link from "next/link";
import { AuthenticationStep } from "@/lib/analytics/segmentEvents";
import { trackAuthFlow } from "@/lib/analytics/trackEvents";

/**
 * Creators land on /discovery expecting to sign in, but their portal is a
 * separate surface with its own auth (/one). Without a signpost they submit
 * their email here, receive nothing, and email support.
 *
 * Deliberately subordinate to the sign-in form above it: a bordered row, not a
 * second filled button. The workspace login is still the page's one primary
 * action.
 */
export function CreatorPortalCallout() {
  const handleClick = () => {
    trackAuthFlow({
      step: AuthenticationStep.DISCOVERY_PAGE,
      additionalParams: { event: "creator portal callout clicked" },
    });
  };

  return (
    <Link
      href="/one"
      onClick={handleClick}
      className="group mt-nf-ds-8 flex items-center gap-nf-ds-4 rounded-nf-ds-2xl border border-border bg-card px-nf-ds-5 py-nf-ds-4 shadow-nf-ds-xs transition-[background-color,box-shadow,transform] duration-150 ease-out hover:bg-nf-ds-bg-surface hover:shadow-nf-ds-sm active:scale-[0.99] motion-reduce:transition-none motion-reduce:active:scale-100"
    >
      <span className="flex min-w-0 grow flex-col gap-nf-ds-1">
        <span className="font-nf-ds-mono text-[12px] font-[500] uppercase tracking-[0.1em] leading-none text-nf-ds-brand">
          For creators
        </span>
        <span className="font-nf-ds-sans text-[14px] font-[500] leading-[1.35] text-nf-ds-text-strong">
          Hey, are you a creator?
        </span>
        <span className="font-nf-ds-sans text-[13px] leading-[1.35] text-muted-foreground">
          Sign in on{" "}
          <span className="text-[15px] font-[600] tracking-[-0.005em] text-nf-ds-text-strong">
            NewForm One
          </span>{" "}
          instead.
        </span>
      </span>
      <span
        aria-hidden
        className="shrink-0 font-nf-ds-sans text-[16px] text-muted-foreground transition-transform duration-150 ease-out group-hover:translate-x-[2px] group-hover:text-nf-ds-text-strong motion-reduce:transition-none motion-reduce:group-hover:translate-x-0"
      >
        →
      </span>
    </Link>
  );
}
